export default ({text, onClick, selected}) => {
    const textColor = selected ? "text-white" : "heading-text";
    const backgroundColor = selected ? "heading-background" : "background-grey";

    if (text == null || text === "") return null;
    return <button onClick={onClick} className={`rounded-full px-4 py-1 my-4 mr-4 text-sm ${textColor} ${backgroundColor}`}>{text}</button>
}
